import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const cbpInvoiceIdsSlice = createSlice({
  name: 'stop/cbpInvoiceIds',
  initialState,
  reducers: {
    getCbpInvoiceIds: (state, action) => action.payload,
    resetCbpInvoiceIds: () => initialState,
  },
});

export const { getCbpInvoiceIds, resetCbpInvoiceIds } =
  cbpInvoiceIdsSlice.actions;
export default cbpInvoiceIdsSlice.reducer;
